"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import type { IconProps } from "../types"
import { getPath } from "../utils"

const ArrowUp = createSvgIcon(
  <path d="M12.0009 9.29808L17.3086 14.6058L16.6009 15.3135L12.0009 10.7135L7.40089 15.3135L6.69319 14.6058L12.0009 9.29808Z" />,
  "ArrowUp",
)

const ArrowUpIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill =
    (fill && getPath(theme.palette, fill)) || theme.palette.text.primary
  return <ArrowUp sx={{ fill: _fill, ...sx }} {...rest} />
}

export default ArrowUpIcon
